import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addMiddleware } from 'redux-dynamic-middlewares';
import { userProfileActions } from 'features/userProfile';
import GoogleAnalyticsCustomDimensions from 'constants/googleAnalyticsCustomDimension';
import layoutStateSlice from './uiStateSlice';
import updateDataLayer from '../components/dataLayer';

const layoutActions = layoutStateSlice.actions;
const listenerMiddleware = createListenerMiddleware();

function updateDataLayerEntry(value) {
  setTimeout(() => { updateDataLayer(value) }, 500);
}

// This listener is in charge to return a custom dimension value to it's default state.
listenerMiddleware.startListening({
  type: layoutActions.trackUserEvent.type,
  effect: (action) => {
    const trackedEvent = action.payload;
    if (GoogleAnalyticsCustomDimensions.PriceReduction().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.PriceReduction().getName()]: null,
      }));
    }
    if (GoogleAnalyticsCustomDimensions.CommunityName().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.CommunityName().getName()]: null,
      }));
    }
    if (GoogleAnalyticsCustomDimensions.BrandName().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.BrandName().getName()]: null,
      }));
    }
    if (GoogleAnalyticsCustomDimensions.SpecId().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.SpecId().getName()]: null,
      }));
    }
    if (GoogleAnalyticsCustomDimensions.PlanId().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.PlanId().getName()]: null,
      }));
    }
    if (GoogleAnalyticsCustomDimensions.CommunityId().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.CommunityId().getName()]: null,
      }));
    }
    if (GoogleAnalyticsCustomDimensions.IsPaid().getName() in trackedEvent.googleAnalyticsDTO)
    {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.IsPaid().getName()]: null,
      }));
    }
  }
});

listenerMiddleware.startListening({
  type: userProfileActions.saveFavoriteFulfilled.type,
  effect: () => {
      updateDataLayerEntry(({
        [GoogleAnalyticsCustomDimensions.SpecId().getName()]: null,
        [GoogleAnalyticsCustomDimensions.PlanId().getName()]: null,
        [GoogleAnalyticsCustomDimensions.CommunityId().getName()]: null,
        [GoogleAnalyticsCustomDimensions.BrandName().getName()]: null,
        [GoogleAnalyticsCustomDimensions.IsPaid().getName()]: null,
      }));
  }
});

addMiddleware(listenerMiddleware.middleware);